{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "即時聊天活動",
      "NEW_CAMPAIGN": "建立活動",
      "CARD": {
        "STATUS": {
          "ENABLED": "已啟用",
          "DISABLED": "已停用"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "發送者",
          "BOT": "機器人",
          "FROM": "來自",
          "URL": "URL："
        }
      },
      "EMPTY_STATE": {
        "TITLE": "目前沒有即時聊天活動",
        "SUBTITLE": "透過主動訊息與您的客戶建立連結。點選「建立活動」以開始。"
      },
      "CREATE": {
        "TITLE": "建立即時聊天活動",
        "CANCEL_BUTTON_TEXT": "取消",
        "CREATE_BUTTON_TEXT": "建立",
        "FORM": {
          "TITLE": {
            "LABEL": "標題",
            "PLACEHOLDER": "請輸入活動標題",
            "ERROR": "標題為必填"
          },
          "MESSAGE": {
            "LABEL": "訊息",
            "PLACEHOLDER": "請輸入活動訊息",
            "ERROR": "訊息為必填"
          },
          "INBOX": {
            "LABEL": "選擇收件匣",
            "PLACEHOLDER": "選擇收件匣",
            "ERROR": "收件匣為必填"
          },
          "SENT_BY": {
            "LABEL": "發送者",
            "PLACEHOLDER": "請選擇發送者",
            "ERROR": "發送者為必填"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "請輸入 URL",
            "ERROR": "請輸入有效的 URL"
          },
          "TIME_ON_PAGE": {
            "LABEL": "頁面停留時間（秒）",
            "PLACEHOLDER": "請輸入時間",
            "ERROR": "頁面停留時間為必填"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "其他設定",
            "ENABLED": "啟用活動",
            "TRIGGER_ONLY_BUSINESS_HOURS": "僅在營業時間觸發"
          },
          "BUTTONS": {
            "CREATE": "建立",
            "CANCEL": "取消"
          },
          "API": {
            "SUCCESS_MESSAGE": "即時聊天活動建立成功",
            "ERROR_MESSAGE": "發生錯誤，請重試。"
          }
        }
      },
      "EDIT": {
        "TITLE": "編輯即時聊天活動",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "即時聊天活動更新成功",
            "ERROR_MESSAGE": "發生錯誤，請重試。"
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "簡訊活動",
      "NEW_CAMPAIGN": "建立活動",
      "EMPTY_STATE": {
        "TITLE": "目前沒有簡訊活動",
        "SUBTITLE": "發起簡訊活動以直接聯繫您的客戶。輕鬆發送優惠或公告。點選「建立活動」以開始。"
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "處理中",
          "COMPLETED": "已完成",
          "SCHEDULED": "已排程"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "發送自",
          "ON": "於"
        }
      },
      "CREATE": {
        "TITLE": "建立簡訊活動",
        "CANCEL_BUTTON_TEXT": "取消",
        "CREATE_BUTTON_TEXT": "建立",
        "FORM": {
          "TITLE": {
            "LABEL": "標題",
            "PLACEHOLDER": "請輸入活動標題",
            "ERROR": "標題為必填"
          },
          "MESSAGE": {
            "LABEL": "訊息",
            "PLACEHOLDER": "請輸入活動訊息",
            "ERROR": "訊息為必填"
          },
          "INBOX": {
            "LABEL": "選擇收件匣",
            "PLACEHOLDER": "選擇收件匣",
            "ERROR": "收件匣為必填"
          },
          "AUDIENCE": {
            "LABEL": "受眾",
            "PLACEHOLDER": "選擇客戶標籤",
            "ERROR": "受眾為必填"
          },
          "SCHEDULED_AT": {
            "LABEL": "排程時間",
            "PLACEHOLDER": "請選擇時間",
            "ERROR": "排程時間為必填"
          },
          "BUTTONS": {
            "CREATE": "建立",
            "CANCEL": "取消"
          },
          "API": {
            "SUCCESS_MESSAGE": "簡訊活動建立成功",
            "ERROR_MESSAGE": "發生錯誤，請重試。"
          }
        }
      }
    },
    "WHATSAPP": {
      "HEADER_TITLE": "WhatsApp 活動",
      "NEW_CAMPAIGN": "建立活動",
      "EMPTY_STATE": {
        "TITLE": "目前沒有 WhatsApp 活動",
        "SUBTITLE": "發起 WhatsApp 活動以直接聯繫您的客戶。輕鬆發送優惠或公告。點選「建立活動」以開始。"
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "處理中",
          "COMPLETED": "已完成",
          "SCHEDULED": "已排程"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "發送自",
          "ON": "於"
        }
      },
      "CREATE": {
        "TITLE": "建立 WhatsApp 活動",
        "CANCEL_BUTTON_TEXT": "取消",
        "CREATE_BUTTON_TEXT": "建立",
        "FORM": {
          "TITLE": {
            "LABEL": "標題",
            "PLACEHOLDER": "請輸入活動標題",
            "ERROR": "標題為必填"
          },
          "INBOX": {
            "LABEL": "選擇收件匣",
            "PLACEHOLDER": "選擇收件匣",
            "ERROR": "收件匣為必填"
          },
          "TEMPLATE": {
            "LABEL": "WhatsApp 範本",
            "PLACEHOLDER": "選擇範本",
            "INFO": "選擇此活動要使用的範本。",
            "ERROR": "範本為必填",
            "PREVIEW_TITLE": "處理 {templateName}",
            "LANGUAGE": "語言",
            "CATEGORY": "類別",
            "VARIABLES_LABEL": "變數",
            "VARIABLE_PLACEHOLDER": "輸入 {variable} 的值"
          },
          "AUDIENCE": {
            "LABEL": "受眾",
            "PLACEHOLDER": "選擇客戶標籤",
            "ERROR": "受眾為必填"
          },
          "SCHEDULED_AT": {
            "LABEL": "排程時間",
            "PLACEHOLDER": "請選擇時間",
            "ERROR": "排程時間為必填"
          },
          "BUTTONS": {
            "CREATE": "建立",
            "CANCEL": "取消"
          },
          "API": {
            "SUCCESS_MESSAGE": "WhatsApp 活動建立成功",
            "ERROR_MESSAGE": "發生錯誤，請重試。"
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "確定要刪除嗎？",
      "DESCRIPTION": "刪除操作是永久性的，無法復原。",
      "CONFIRM": "刪除",
      "API": {
        "SUCCESS_MESSAGE": "活動刪除成功",
        "ERROR_MESSAGE": "發生錯誤，請重試。"
      }
    }
  }
}
